import { DsmIcon } from "@dsm-dcs/design-system-react";
import { Grid, Typography } from "@material-ui/core";
import { type FC, MouseEvent } from "react";
import Can from "../../../modules/Auth/Can";
import { DsmButtonV2 } from "../helpers/DsmButton";
import { DSM_BLUE, DSM_DARK_GREY } from "../../../../_metronic/layout";
import { Spacer } from "../helpers/Spacer";

interface PageHeaderProps {
  title: string;
  description: string;
  canSubject: string;
  createButtonText: string;
  createHandler: () => Promise<void>;
  horizontalRule?: boolean;
}

const PageHeader: FC<PageHeaderProps> = ({
  title,
  description,
  canSubject,
  createButtonText,
  createHandler,
  horizontalRule = false,
}) => {
  const handleCreateClick = (
    event: MouseEvent<HTMLDsmButtonElement, globalThis.MouseEvent>,
  ) => {
    event.preventDefault();
    createHandler().catch(console.error); // Handle any errors thrown by fetchData
  };

  const getAddButton = () => {
    if (canSubject === "Compound Feed") {
      return (
        <DsmButtonV2
          href="/v2/feeds/add"
          style={{ float: "right", marginTop: "20px" }}
        >
          <DsmIcon
            name="general/plus"
            style={{ paddingRight: "5px", height: "24px", width: "24px" }}
          />
          {createButtonText}
        </DsmButtonV2>
      );
    }
    return (
      <DsmButtonV2
        onClick={handleCreateClick}
        style={{ float: "right", marginTop: "20px", whiteSpace: "nowrap" }}
      >
        <DsmIcon
          name="general/plus"
          style={{ paddingRight: "5px", height: "24px", width: "24px" }}
        />
        {createButtonText}
      </DsmButtonV2>
    );
  };

  return (
    <>
      <Grid container>
        <Grid item xs={10}>
          <Typography
            variant="h4"
            style={{
              color: `${DSM_BLUE}`,
              fontWeight: 500,
              marginBottom: "8px",
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body1"
            style={{
              color: `${DSM_DARK_GREY} !important`,
            }}
          >
            {description}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          {Can("create", canSubject) && getAddButton()}
        </Grid>
      </Grid>
      {horizontalRule && <hr style={{ margin: 0, marginTop: "16px" }} />}
    </>
  );
};

export default PageHeader;
